import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostFeldUnterkategorieCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostFeldUnterkategorieCommandService],
  exports: []
})
export class PostFeldUnterkategorieCommandServiceModule { }
